var _defs, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoInstagram(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "15.17mm",
    height: "15.78mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 43 44.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#Degradado_sin_nombre);isolation:isolate;opacity:.8;}.cls-3{fill:#d11664;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre",
    cx: 21.5,
    cy: 22.84,
    fx: 21.5,
    fy: 22.84,
    r: 21.5,
    gradientTransform: "translate(0 46.07) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#7474a4",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#d8d8e5",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 21.5,
    cy: 23.22,
    r: 21.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 16.26,
    cy: 14.62,
    r: 14.62
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m20.8,9.09c-.55,0-1,.45-1,1.01s.45,1.01,1,1.01,1.01-.45,1.01-1.01-.45-1.01-1.01-1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m16.33,10.38c-2.33,0-4.22,1.89-4.22,4.22s1.89,4.22,4.22,4.22,4.22-1.89,4.22-4.22-1.89-4.22-4.22-4.22Zm0,6.93c-1.49,0-2.7-1.21-2.7-2.7s1.21-2.7,2.7-2.7,2.7,1.21,2.7,2.7-1.21,2.7-2.7,2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m19.68,23.18h-6.84c-2.84,0-5.15-2.31-5.15-5.15v-6.84c0-2.84,2.31-5.15,5.15-5.15h6.84c2.84,0,5.15,2.31,5.15,5.15v6.84c0,2.84-2.31,5.15-5.15,5.15Zm-6.84-15.53c-1.95,0-3.54,1.59-3.54,3.54v6.84c0,1.95,1.59,3.54,3.54,3.54h6.84c1.95,0,3.54-1.59,3.54-3.54v-6.84c0-1.95-1.59-3.54-3.54-3.54,0,0-6.84,0-6.84,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoInstagram);
export default __webpack_public_path__ + "static/media/logoInstagram.03c4104ca554cc76e211d52d6ac44159.svg";
export { ForwardRef as ReactComponent };